import { Link } from "react-router-dom";
import "../../assets/css/wes-privacy-policy.css";

export const PrivacyPolicy = () => {
  return (
    <main className="wes-privacy-policy-content">
      <section className="wes-privacy-policy-style-1">
        <div className="wes-privacy-policy-style-2">
          <nav aria-label="Breadcrumb" className="wes-privacy-policy-style-3">
            <Link to="/" className="wes-privacy-policy-style-4">
              Home
            </Link>
            <span aria-hidden="true">›</span>
            <span className="wes-privacy-policy-style-5">Privacy Policy</span>
          </nav>
          <div className="wes-privacy-policy-style-6">
            <span className="wes-privacy-policy-style-7">Legal</span>
            <h1 className="wes-privacy-policy-style-8">Privacy Policy</h1>
          </div>
        </div>
      </section>

      <section>
        <div className="wes-privacy-policy-style-9">
          <article className="wes-simple">
            <section>
              <h2>Who we are</h2>
              <p>
                WES Australasia, trading as WES Components A/Asia (ABN 54 697 959 318), is an Australian
                business-to-business distributor of electronic components, equipment and accessories.
              </p>
            </section>
            <section>
              <h2>What we collect</h2>
              <p>We only collect what we need to do business with you. This may include:</p>
              <ul>
                <li>names, job titles and business contact details;</li>
                <li>
                  information for trade credit applications, including director or guarantor details and credit reports;
                </li>
                <li>website and cookie data, such as pages visited; and</li>
                <li>resumes and details from job applicants.</li>
              </ul>
              <p>
                We collect most information directly from you, for example when you open an account, place an order,
                call or email us, or visit our website or trade counter.
              </p>
            </section>
            <section>
              <h2>How we use it</h2>
              <p>
                We use your information to process orders and deliveries, manage trade accounts and credit, provide
                customer service and support, send product updates and offers, consider job applications, and meet our
                legal obligations.
              </p>
              <p>
                <strong>We never sell or rent your personal information.</strong>
              </p>
            </section>
            <section>
              <h2>Who we share it with</h2>
              <p>
                We only share information when needed to provide our services — for example with freight carriers,
                payment providers, IT and cloud service providers, credit reporting bodies, and our professional
                advisers — or when required by law.
              </p>
            </section>
            <section>
              <h2>Marketing</h2>
              <p>
                We may send you news, catalogues and special offers. You can unsubscribe at any time using the link in
                our emails or by contacting us.
              </p>
            </section>
            <section>
              <h2>Cookies</h2>
              <p>
                Our website uses cookies to keep you signed in, remember your cart and understand how the site is used.
              </p>
            </section>
            <section>
              <h2>Keeping it safe</h2>
              <p>
                We take reasonable steps to protect your information from misuse, loss and unauthorised access, and we
                securely delete it when it is no longer needed.
              </p>
            </section>
            <section>
              <h2>Complaints</h2>
              <p>
                To make a privacy complaint, please contact us using the details below. We aim to respond within 30
                days.
              </p>
            </section>
            <section>
              <h2>Contact us</h2>
              <div className="wes-privacy-policy-style-10">
                <strong className="wes-privacy-policy-style-11">Privacy Officer, WES Australasia</strong>
                <span>84-90 Parramatta Road, Summer Hill NSW 2130</span>
                <span>
                  Phone: <a href="tel:+61297979866">(02) 9797 9866</a>
                </span>
                <span>
                  Email: <a href="mailto:privacy@wes.com.au">privacy@wes.com.au</a>
                </span>
              </div>
              <p className="wes-privacy-policy-style-12">
                We may update this policy from time to time. The latest version will always be on our website.
              </p>
            </section>
          </article>
        </div>
      </section>
    </main>
  );
};
